import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInputArea } from "./FormInputArea";

interface Props {
    name: string
    value?: string | number
    label: string
    className?: string
    placeholder?: string
    isDisabled?: boolean

    control: any
    isRequired?: boolean
}

export const ReactiveFormInputArea = (props: Props) => {
    const { t } = useTranslation();
    
    return (
        <Controller
            name={props.name}
            control={props.control}
            rules={{ required: props.isRequired ?? false }}
            render={({
                field: { onChange, value },
                fieldState: { error },
            }) => {
                return (<FormInputArea
                    label={props.label}
                    name={props.name}
                    value={value}
                    handleOnChange={onChange}
                    error={error ? error.message ? error.message : t("FIELD_REQUIRED") : ""}
                    className={props.className}
                    placeholder={props.placeholder} />)
            }} />
    )
}